"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomizrClient = void 0;

var _baseclient = require("./baseclient");

const LOUDSPEAKER_RESOURCE_ID = 'loudspeaker';
const CUSTOMIZR_BASE_URL = 'https://customizr.at.cimpress.io';

class CustomizrClient extends _baseclient.BaseClient {
  constructor(configuration) {
    super(configuration);
    this.loudspeakerSettings = {};
  }

  async getLastAcknowledgementTimestamps() {
    try {
      const response = await fetch(`${CUSTOMIZR_BASE_URL}/v1/resources/${LOUDSPEAKER_RESOURCE_ID}/settings`, {
        method: 'GET',
        headers: this.headers
      });

      if (!response.ok) {
        throw new Error('Loudspeaker: Failed to retrieve last acknowledgement timestamps.');
      }

      this.loudspeakerSettings = await response.json();
    } catch (error) {
      console.warn(error.message);
      this.loudspeakerSettings = {};
    }

    const timestamps = {};
    this.channelIds.forEach(channelId => {
      if (this.loudspeakerSettings && this.loudspeakerSettings[channelId]) {
        timestamps[channelId] = this.loudspeakerSettings[channelId].lastAcknowledgementTimestamp;
      }
    });
    return timestamps;
  }
  /**
   * Set the new "acknowledgement timestamp" for all viewed channels.
   */


  async acknowledgeAnnouncements(lastAcknowledgementTimestamp) {
    const body = Object.assign({}, this.loudspeakerSettings);
    this.channelIds.forEach(channelId => {
      body[channelId] = {
        lastAcknowledgementTimestamp
      };
    });

    try {
      const response = await fetch(`${CUSTOMIZR_BASE_URL}/v1/resources/${LOUDSPEAKER_RESOURCE_ID}/settings`, {
        method: 'PUT',
        headers: this.headers,
        body: JSON.stringify(body)
      });

      if (!response.ok) {
        throw new Error('Loudspeaker: Failed to acknowledge announcements.');
      }
    } catch (error) {
      console.warn(error.message);
    }
  }

}

exports.CustomizrClient = CustomizrClient;